module.exports = __webpack_public_path__ + "a9882aae41e90475132819ffc0057117.svg";